import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  export(e) {
    e.preventDefault();
    let filterParams = filtersFormData($(".filters-form"));
    let url = `${this.data.get("url")}?`;

   exportFile(url, filterParams)
  }
}
